export const AppSearch = () => {
// Kept out of the returned object: Alpine proxies its data and AbortController#signal is a private slot.
let controller: AbortController | null = null

return {
    open: false,
    isLoading: false,
    search: '',
    results: [],

    get isFocused() {
        return document.body.classList.contains('is-searchOpened')
    },
    get groupedResults() {
        if (this.isLoading) return []

        const groups = [
            { type: 'offers', title: this.$el?.dataset.offersLabel ?? 'Nabídky', limit: 5, items: [] },
            { type: 'operak', title: this.$el?.dataset.operakLabel ?? 'Operativní leasingy', limit: 10, items: [] },
            { type: 'post', title: this.$el?.dataset.blogLabel ?? 'Magazín', limit: 3, items: [] },
        ]

        this.results.forEach(result => {
            const group = groups.find(e => e.type === (result.details?.isOperak ? 'operak' : result.subtype))
            if (group && group.items.length < group.limit) group.items.push(result)
        })

        return groups
    },

    async loadResults(term = '') {
        const searchApi = `/wp-json/wp/v2/search/?search=${encodeURIComponent(term)}&subtype[]=post&subtype[]=offers&per_page=30&collapse_variants=1&wpessid`
        this.isLoading = true;

        controller?.abort()

        if (term.length > 1) {
            const request = controller = new AbortController();
            this.open = true;

            await fetch(`${searchApi}`, {signal: request.signal})
                .then((response) => response.json())
                .then((data) => {
                    this.results = data;
                })
                .catch((e) => {
                    if (e.name === "AbortError") return; // We know it's been canceled!
                    console.log(e)
                })
                // A superseded request must not clear the loader the newer one just turned on.
                .finally(() => { if (controller === request) this.isLoading = false })
        } else {
            controller = null;
            this.isLoading = false;
            this.closeSearch(true)
            this.results = [];
        }
    },

    closeSearch(soft = false) {
        if (!soft) {
            document.body.classList.remove('is-searchOpened')
            document.activeElement?.blur()
        }

        this.open = false
    },

    searchInput: {
        // ['x-model']() { return this.search }, ??? WTF ???
        ['@input.debounce.400ms']() { this.loadResults(this.search) },
        ['@focus']() { document.body.classList.add('is-searchOpened') },
        ['@click.outside']() { this.isFocused && this.closeSearch() }
    },
    searchCloser: {
        ['@click']() { this.closeSearch() }
    },
    searchResults: {
        ['x-show']() { return this.open }
    },
    searchResult: {
        [':href']() { return this.result.url },
        [':class']() { return `AppSearchResult--${this.result.subtype}` }
    },
    searchShowMore: {
        [':href']() {
            return this.search.length
                ? `${this.$el.dataset.url}?${this.$el.dataset.slug}=${this.search}` : this.$el.dataset.url
        }
    }
}
}